export default __webpack_public_path__ + "static/media/1515.330c2401.png";